"use client";

import { useRouter } from "next/navigation";
import { useTransition } from "react";
import { Button } from "@boostdev/design-system-components/client";

export interface RetryButtonProps {
  readonly label: string;
}

/**
 * Client island for the album-error state: triggers `router.refresh()` which
 * re-invokes the server component and therefore re-runs the resolver. Lives
 * inside the otherwise-server PhotoCodeAlbum.
 */
export function RetryButton({ label }: RetryButtonProps) {
  const router = useRouter();
  const [pending, startTransition] = useTransition();

  return (
    <Button
      variant="outline"
      disabled={pending}
      onClick={() => startTransition(() => router.refresh())}
    >
      {label}
    </Button>
  );
}
